import { render } from "./InvoiceStaffCard.vue?vue&type=template&id=23169670"
import script from "./InvoiceStaffCard.vue?vue&type=script&lang=js"
export * from "./InvoiceStaffCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__